import { Link } from "react-router-dom";

import { INTERNAL_ROUTES } from "@/routes_new";

import styles from "./Breadcrumbs.module.css";

const Breadcrumbs: React.FunctionComponent<{
  channel_name?: string;
}> = ({ channel_name }) => {
  return (
    <div className={styles.breadcrumbs}>
      <a className={styles.link} href="/internal/">
        Internal
      </a>
      /
      {channel_name ? (
        <>
          <Link className={styles.link} to={INTERNAL_ROUTES.CHANNEL_LIST}>
            Channels
          </Link>
          /<span>{channel_name}</span>
        </>
      ) : (
        <span>Channels</span>
      )}
    </div>
  );
};

export default Breadcrumbs;
